import { Component, Input, OnInit, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MainBusinessRecord } from '@core/models'
import { SelectOption } from '@core/models/response/select-object-options'
import {
    WorkspaceFacadeService,
    SchemaFacadeService,
    UserFacadeService,
} from '@core/services/store-facade'
import { TranslocoService, TranslocoModule } from '@jsverse/transloco'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { combineLatest } from 'rxjs'
import { RecordCardNavigationService } from '@app/pages/service/record-card-navigation.service'

@UntilDestroy()
@Component({
    selector: 'app-search-results-item',
    templateUrl: './search-results-item.component.html',
    styleUrls: ['./search-results-item.component.sass'],
    imports: [TranslocoModule],
})
export class SearchResultsItemComponent implements OnInit {
    dialog = inject(MatDialog)
    private readonly translation = inject(TranslocoService)
    private readonly schemaFacadeService = inject(SchemaFacadeService)
    private readonly workspaceFacadeService = inject(WorkspaceFacadeService)
    private readonly userFacadeService = inject(UserFacadeService)
    private readonly recordCardNavigationService = inject(RecordCardNavigationService)

    @Input()
    record!: MainBusinessRecord

    name!: string
    assignee!: string
    status!: SelectOption
    created!: string
    workspace!: string
    assigned!: string

    ngOnInit() {
        combineLatest([
            this.schemaFacadeService.selectSchemaByGuid$(this.record.schema_guid),
            this.userFacadeService.userEntities$,
            this.workspaceFacadeService.selectSelectedWorkspace$,
            this.translation.selectTranslateObject('search.results'),
        ])
            .pipe(untilDestroyed(this))
            .subscribe(([schema, users, workspace, names]) => {
                if (schema) {
                    this.name = this.record.name.value

                    const workspaceGuid = workspace.guid
                    const assignee = this.record.assignee[workspaceGuid].value

                    const user = users ? users[assignee] : null
                    this.assignee =
                        assignee && user
                            ? user.first_name + ' ' + user.last_name
                            : names['assigned']
                }
            })
    }

    openSearchItem() {
        this.recordCardNavigationService.openRecordCard({
            recordGuid: this.record.guid,
            isWorkspace: true,
        })
    }
}
